'use client';

import { useMemo, useState } from 'react';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { calculateRoeRoa } from './calculations';
import { RoeRoaValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['roeRoa'];
}

export default function RoeRoaCalculator({ translations }: Props) {
  const [values, setValues] = useState<RoeRoaValues>({
    netIncome: 1_200_000,
    totalAssets: 15_000_000,
    shareholdersEquity: 6_000_000,
  });

  const handleValuesChange = (field: string | number | symbol, value: number) => {
    const key = field as keyof RoeRoaValues;
    setValues(prev => ({ ...prev, [key]: value }));
  };

  const result = useMemo(() => calculateRoeRoa(values), [values]);

  return (
    <section id="roe-roa-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center justify-between gap-4">
            <div>
              <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
              <p className="text-sm text-gray-600 mt-0.5">{translations.subtitle}</p>
            </div>
          </div>
        </div>
        <div className="p-6 space-y-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <CalculatorInputs values={values} onValuesChange={handleValuesChange} translations={translations} />
            <ResultsDisplay result={result} translations={translations} />
          </div>
          <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
            <h4 className="text-sm font-semibold text-yellow-900 mb-2">{translations.disclaimerTitle}</h4>
            <p className="text-sm text-yellow-800">{translations.disclaimerText}</p>
          </div>
        </div>
      </div>
    </section>
  );
}


